/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { type SortAttributeType } from '../interface/types';

export const DEFAULT_SORT_ATTRIBUTE: SortAttributeType = 'MOST_RECENT';
